<div class="dialog dialog--template-text">
    <header mat-dialog-title class="dialog__header modal-header pl-4 pr-4">
        <span>Template Text</span>
        <button mat-dialog-close class="close close-btn" type="button"><ds-icon name="close" size="inherit"></ds-icon></button>
    </header>
    <mat-dialog-content>
        <section class="dialog__content">
            <div *ngIf="paragraphs">
                <p *ngFor="let paragraph of paragraphs" class="template-text-dialog__paragraph">{{ paragraph }}</p>
            </div>
            <footer class="form__footer">
                <button class="flat-butt flat-danger-butt flat-danger-grad-butt" type="button" (click)="copyToClipboard()">
                    Copy Template
                </button>
                <button mat-dialog-close class="flat-butt flat-danger-butt flat-danger-grad-butt" type="button">Close</button>
            </footer>
        </section>
    </mat-dialog-content>
</div>
